"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureLooksLikeEnumFlag = ensureLooksLikeEnumFlag;
exports.getAllEnumFlagNames = getAllEnumFlagNames;
exports.getEnumFlags = getEnumFlags;
exports.toEnumFlags = toEnumFlags;
var _lodash = require("@avantia/lodash");
var _loggingAndErrors = require("@avantia/logging-and-errors");
/**
 * Converts a string representation of flags into a numeric one.
 * @param debugWhich a list of strings that represent values of an enum. e.g. 'TimeTaken, AjaxRequests' (white-space is optional).
 * @param enumType the instance of an enum, e.g. HpDebugFlags
 * @returns a number representation of the 'debugWhich' provided.
 */
function toEnumFlags(debugWhich, enumType) {
  ensureLooksLikeEnumFlag(enumType);
  return String(debugWhich).split(',').map(key => key.trim()).map(key => enumType[key] || 0).reduce((v, c) => v + c);
}

/**
 * From an enum number, provides an array of flags that are selected.
 * @param mode e.g. 3
 * @param enumType the instance of an enum, e.g. HpDebugFlags
 * @returns an array of flag names, e.g. ['TimeTaken', 'AjaxRequests']
 */
function getEnumFlags(mode, enumType) {
  ensureLooksLikeEnumFlag(enumType);
  const res = [];
  const debug = mode || 0;
  getAllEnumFlagNames(enumType).forEach(key => {
    const number = enumType[key];
    if ((debug & number) > 0) {
      res.push(key);
    }
  });
  return res;
}

/**
 * Gets all enum values except for 'None' and 'All'.
 * @param enumType the instance of an enum, e.g. HpDebugFlags
 * @returns an array of flag names, e.g. ['TimeTaken', 'AjaxRequests']
 */
function getAllEnumFlagNames(enumType) {
  ensureLooksLikeEnumFlag(enumType);
  const res = _lodash.lodash.keys(enumType).filter(v => v !== 'None' && v !== 'All' && isNaN(parseInt(v, 10)));
  res.sort();
  return res;
}
function ensureLooksLikeEnumFlag(enumType) {
  const looksLikeEnum = !!enumType && typeof enumType === 'object' && enumType.None === 0 && typeof enumType.All === 'number' && enumType.All > 0;
  if (!looksLikeEnum) {
    throw new _loggingAndErrors.HpError(`The value provided does not appear to be an enum value.`);
  }
}